import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Accordion, Button, Card, Col, Container, Row } from "react-bootstrap";
import Nav from "./Navbar";
import Footer from "./Footer";
import toolten from "../Images/tool10.png";
import tool14 from "../Images/tool14.png";
import tool15 from "../Images/tool15.svg";
const Linkbuilding = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const script = document.createElement("script");
    script.type = "module";
    script.src = "/off_seo.js";
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Container fluid className="p-0" style={{ overflowX: "hidden" }}>
      <div>
        {/* <div
          className="d-flex justify-content-center"
          style={{ background: "#fdca40" }}
        >
          <p className="p-2 m-0 text-center">
            Start with free trial of <b>SeoBix!</b> - boost your SEO
            game&nbsp;&nbsp;
            <Button size="sm" variant="success">
              Know More
            </Button>
          </p>
        </div> */}
        <Nav />
      </div>

      <Row className="d-flex justify-content-center mt-4">
        <Col className="col-md-10 col-12 ">
          <div className="mx-2">
            <h1 className="text-center m-3 ">
              Tracks and Records Every Backlink in one place
            </h1>

            <p>
              Search engines might change, but one thing remains constant:
              backlinks are still much of the criteria for obtaining an
              excellent rank on Google. If you are serious about enhancing your
              visibility on the internet, building a strong and healthy link
              profile is the way to go. But here lies the problem: most backlink
              statistics you get from SEO tools are rather basic in comparison.
              That is, in fact, what makes Seobix different. Instead of focusing
              on the more common issues, Seobix is designed for the 2025.
            </p>
            <div className="d-flex justify-content-center mt-3 mb-3">
              <img
                className="m-4"
                src={tool14}
                alt="seobix"
                style={{ width: "65vw" }}
              />
            </div>
            <h2>Why Link Building Still Rules in 2025</h2>

            <p>
              No matter the algorithm updates, link building remains a critical
              factor to rank websites. Be you a beginner or a pro in SEO,
              backlinks are the key to organic growth. But now, here's the catch
              - it's tough to really find a great link-building tool that
              doesn't just check backlinks but also gives deeper insights into
              it. That's exactly where Seobix enters the game.
            </p>

            <h2>Keeps Your Backlink History Safe and Organized</h2>

            <p>
              Unlike other tools, Seobix gives you a full <b>backlink record</b>{" "}
              of any website — yours or your competitor's. Want to know which
              links were lost last month? Or which ones are newly added this
              week? Seobix keeps that history for you. That’s gold when you’re
              making a link-building strategy.
            </p>

            <h2>One Dashboard. All Your Link Insights.</h2>

            <p>
              Managing backlinks from multiple sources can be a pain. Seobix
              solves this problem by showing everything on one clean dashboard.
              Domain rating, source page title, linking text, type of link
              (dofollow or nofollow), and much more — all in one place.
            </p>

            <h2>Is Seobix the Right Tool for You?</h2>

            <p>
              Seobix is built for true SEO professionals. If you are an SEO
              freelancer handling several client websites, Seobix helps you keep
              track of backlinks and formulate smarter strategies. If you are an
              agency focused on building authority sites, the tool gives you an
              edge with exceedingly detailed backlink analysis. If you're a
              business trying to outrank competitors, Seobix makes link-building
              much easier, quicker, and more efficient, without the hassle of
              hopping from one tool to the other.
            </p>
            <div className="d-flex justify-content-center mt-3 mb-3">
              <img
                className="mb-3"
                src={tool15}
                alt="seobix"
                style={{ width: "65vw" }}
              />
            </div>
            <h2>How Seobix Makes Link Building Easy</h2>

            <p>
              We all know link building is hard. It's time-consuming. Outreach
              emails, rejection, and then figuring out what worked? Stressful.
              Seobix changes the game in two big ways:
            </p>

            <h3>1. Clear Backlink Tracking</h3>

            <p>
              Tracking the quality and quantity of your backlinks over time can
              be tough, but not with Seobix. It gives you a complete view of
              your link profile, so you always know what’s helping and what’s
              hurting your SEO. No guesswork, just clear insights.
            </p>

            <h3>2. Competitor Link Breakdown</h3>

            <p>
              Find out where your top competitors are getting their links from.
              Then, go after those opportunities. With Seobix, every backlink
              becomes a lead for your next win.
            </p>

            <h2>User-Friendly, High-Impact Performance</h2>

            <p className="mb-3">
              Seobix is, without a doubt, for those not as techie or SEO-savvy.
              Just so easy to use. It'd be handy for that novice trying to build
              the first 10 backlinks in their life, as well as for the advanced
              user managing a portfolio of domains.
            </p>
          </div>
        </Col>
      </Row>

      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background: "#31393C",
          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </Container>
  );
};

export default Linkbuilding;
